import { IndicationRequestParams } from '@lio/api-types';
import { indicationQueryKey } from '@services/indications/keys';
import { indicationMetadataQueryKey } from '@services/indications/useIndicationMetadata';

import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useDeleteIndication = () => {
  const queryClient = useQueryClient();

  const client = useClient();
  const result = useMutation({
    mutationFn: (request: IndicationRequestParams) => client.delete(`indication/${request.indicationId}`),
    onSuccess: (_, variables) => {
      // invalidate get
      queryClient.invalidateQueries({
        queryKey: indicationQueryKey.getWithParams({ indicationId: variables.indicationId }),
      });
      // indicate search
      queryClient.refetchQueries({
        predicate: (query) => query.queryKey.includes(indicationQueryKey.search[0]),
      });
      // metadata cache
      queryClient.invalidateQueries({
        queryKey: [indicationMetadataQueryKey],
      });
    },
  });
  return { ...result, deleteIndication: result.mutateAsync };
};
